import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import styled from '@mui/system/styled'

export const textColor = 'text.wildSand'

export const StyledContainer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  minHeight: '100vh',
  overflow: 'hidden',
}))

export const StyledExpandButton = styled((props) => (
  <Button {...props} size="small" variant="outlined" />
))(() => ({
  fontSize: '17px',
  minWidth: 110,
  '&:hover img': { filter: 'brightness(100) grayscale(1) invert(1)' },
}))

export const StyledFloatButton = styled(Button)(() => ({
  position: 'absolute',
  top: 30,
  zIndex: 3,
  fontSize: '17px',
  ':hover': { img: { filter: 'brightness(100) grayscale(1) invert(1)' } },
}))

export const height = '100vh'

export const StyledCircularBox = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(255, 255, 255, 0.4)',
  zIndex: 998,
}))

export const StyledCircularLoader = styled((props) => (
  <CircularProgress {...props} size="50px" />
))(() => ({
  display: 'inline-block',
  position: 'absolute',
  top: 'calc(50% - 25px)',
  left: 'calc(50% - 25px)',
  zIndex: 999,
}))

export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    placement="bottom-start"
    classes={{ popper: className }}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '18px',
  },
}))
